export const ROUTES_CONFIG = {
  ['/forgot-password']: {
    path: '/forgot-password',
    title: 'Forgot Password',
  },
  ['/reset-password']: {
    path: '/reset-password',
    title: 'Reset Password',
  },
  ['/']: {
    path: '/',
    title: 'Chat',
  },
  ['/art']: {
    path: '/art',
    title: 'Art',
  },
  ['/art/:id']: {
    path: '/art/:id',
    title: 'Art',
    useRegexForMatching: true,
    regex: /\/art\/([a-z A-Z 0-9]*)$/,
  },
  ['/art/:id/chat']: {
    path: '/art/:id/chat',
    title: 'Art Chat',
    useRegexForMatching: true,
    regex: /\/art\/([a-z A-Z 0-9]*)\/chat$/,
  },
  ['/art/:id/chat/:conversationId']: {
    path: '/art/:id/chat/:conversationId',
    title: 'Art Chat',
    useRegexForMatching: true,
    regex: /\/art\/([a-z A-Z 0-9]*)\/chat\/([a-z A-Z 0-9]*)$/,
  },
  ['/art/chat/:id']: {
    path: '/art/chat/:id',
    title: 'Art Chat',
    useRegexForMatching: true,
    regex: /\/art\/chat\/([a-z A-Z 0-9]*)$/,
  },
  ['/art/chat/:id/:conversationId']: {
    path: '/art/chat/:id/:conversationId',
    title: 'Art Chat',
    useRegexForMatching: true,
    regex: /\/art\/chat\/([a-z A-Z 0-9]*)\/([a-z A-Z 0-9]*)$/,
  },
  ['/my-artwork']: {
    path: '/my-artwork',
    title: 'My Artwork',
  },
  ['/chat']: {
    path: '/chat',
    title: 'Chat',
  },
  ['/chat/:conversationId']: {
    path: '/chat/:conversationId',
    title: 'Chat',
    useRegexForMatching: true,
    regex: /\/chat\/([a-z A-Z 0-9]*)$/,
  },
  ['/messages']: {
    path: '/messages',
    title: 'Messages',
  },
  ['/messages/new']: {
    path: '/messages/new',
    title: 'New Message',
  },
  ['/messages/:id']: {
    path: '/messages/:id',
    title: 'Conversation',
    useRegexForMatching: true,
    regex: /\/messages\/([a-z A-Z 0-9-]*)$/,
  },
  ['/network']: {
    path: '/network',
    title: 'My Network',
  },
  ['/network/connections']: {
    path: '/network/connections',
    title: 'Connections',
  },
  ['/network/requests']: {
    path: '/network/requests',
    title: 'Connection Requests',
  },
  ['/network/discover']: {
    path: '/network/discover',
    title: 'Discover Artists',
  },
  ['/contacts']: {
    path: '/contacts',
    title: 'Contacts',
  },
  ['/shared/:chatId']: {
    path: '/shared/:chatId',
    title: 'Shared Chat',
    useRegexForMatching: true,
    regex: /\/shared\/([a-z A-Z 0-9-]*)$/,
  },
  ['/eval/:chatId']: {
    path: '/eval/:chatId',
    title: 'Eval Format',
    useRegexForMatching: true,
    regex: /\/eval\/([a-z A-Z 0-9-]*)$/,
  },
  ['/settings']: {
    path: '/settings',
    title: 'Settings',
  },
  ['/saved']: {
    path: '/saved',
    title: 'Saved',
  },
  ['/tutorials']: {
    path: '/tutorials',
    title: 'Tutorials',
  },
  ['/upload']: {
    path: '/upload',
    title: 'Add artwork',
  },
  ['/tools/mocks/:imageId']: {
    path: '/tools/mocks/:imageId',
    title: 'Mocks',
    useRegexForMatching: true,
    regex: /\/tools\/mocks\/([a-z A-Z 0-9]*)$/,
  },
  ['/plans']: {
    path: '/plans',
    title: 'Plans',
  },
  ['/billing']: {
    path: '/billing',
    title: 'Billing',
  },
  ['/admin']: {
    path: '/admin',
    title: 'Admin',
  },
  ['/admin/home']: {
    path: '/admin/home',
    title: 'Admin Home',
  },
  ['/admin/metrics']: {
    path: '/admin/metrics',
    title: 'Admin Metrics',
  },
  ['/admin/dashboard']: {
    path: '/admin/dashboard',
    title: 'Admin Dashboard (Redirect)',
  },
  ['/admin/users']: {
    path: '/admin/users',
    title: 'Admin Users',
  },
  ['/admin/badges']: {
    path: '/admin/badges',
    title: 'Admin Badges',
  },
  ['/admin/contests']: {
    path: '/admin/contests',
    title: 'Admin Contests',
  },
  ['/admin/feed-cards']: {
    path: '/admin/feed-cards',
    title: 'Admin Platform Feed Cards',
  },
  ['/admin/feed-strategies']: {
    path: '/admin/feed-strategies',
    title: 'Admin Feed Strategies',
  },
  ['/admin/quests']: { path: '/admin/quests', title: 'Admin Quests' },
  ['/admin/quests/:id']: { path: '/admin/quests/:id', title: 'Admin Quest Editor' },
  ['/admin/bounties']: { path: '/admin/bounties', title: 'Admin Bounties' },
  ['/admin/bounties/:id']: { path: '/admin/bounties/:id', title: 'Admin Bounty Editor' },
  ['/admin/referrals']: { path: '/admin/referrals', title: 'Admin Referrals' },
  ['/admin/dm-translation']: { path: '/admin/dm-translation', title: 'Admin DM Translation' },
  ['/admin/pre-feeds']: {
    path: '/admin/pre-feeds',
    title: 'Admin Pre-Feeds',
  },
  ['/admin/pre-feeds/:id']: {
    path: '/admin/pre-feeds/:id',
    title: 'Admin Pre-Feed Editor',
  },
  ['/admin/sparklinks']: {
    path: '/admin/sparklinks',
    title: 'Admin Sparklinks',
  },
  ['/admin/marketing-links']: {
    path: '/admin/marketing-links',
    title: 'Admin Marketing Links',
  },
  ['/admin/points']: {
    path: '/admin/points',
    title: 'Admin Points',
  },
  ['/admin/rewards']: {
    path: '/admin/rewards',
    title: 'Admin Rewards',
  },
  ['/admin/verification-requests']: {
    path: '/admin/verification-requests',
    title: 'Admin Verification Requests',
  },
  ['/admin/unmatched-claims']: {
    path: '/admin/unmatched-claims',
    title: 'Admin Unmatched Claims',
  },
  ['/admin/sparks']: {
    path: '/admin/sparks',
    title: 'Admin Sparks',
  },
  ['/admin/sparks/edit/:id']: {
    path: '/admin/sparks/edit/:id',
    title: 'Admin Spark Edit',
    useRegexForMatching: true,
    regex: /\/admin\/sparks\/edit\/([a-z A-Z 0-9]*)$/,
  },
  ['/admin/sparks/add']: {
    path: '/admin/sparks/add',
    title: 'Admin Spark Add',
  },
  ['/admin/features']: {
    path: '/admin/features',
    title: 'Admin Features',
  },
  ['/admin/nav-config']: {
    path: '/admin/nav-config',
    title: 'Admin Global Nav',
  },
  ['/admin/mocks']: {
    path: '/admin/mocks',
    title: 'Admin Mocks',
  },
  ['/admin/chats']: {
    path: '/admin/chats',
    title: 'Admin Chats',
  },
  ['/admin/chats/:id']: {
    path: '/admin/chats/:id',
    title: 'Admin Chat Detail',
    useRegexForMatching: true,
    regex: /\/admin\/chats\/([a-z A-Z 0-9]*)$/,
  },
  ['/admin/community']: {
    path: '/admin/community',
    title: 'Community',
  },
  ['/admin/profiles']: {
    path: '/admin/profiles',
    title: 'Admin Profiles',
  },
  ['/admin/profiles/:id']: {
    path: '/admin/profiles/:id',
    title: 'Admin Profile Details',
    useRegexForMatching: true,
    regex: /\/admin\/profiles\/([a-z A-Z 0-9]*)$/,
  },
  ['/admin/import-artists']: {
    path: '/admin/import-artists',
    title: 'Import Artists',
  },
  ['/admin/community-invites']: {
    path: '/admin/community-invites',
    title: 'Community Invites',
  },
  ['/admin/artist-spotlight']: {
    path: '/admin/artist-spotlight',
    title: 'Artist Spotlight',
  },
  ['/admin/moderation']: {
    path: '/admin/moderation',
    title: 'Moderation',
  },
  ['/admin/geographic-centrality']: {
    path: '/admin/geographic-centrality',
    title: 'Geographic Centrality',
  },
  ['/admin/artist-genome']: {
    path: '/admin/artist-genome',
    title: 'Artist Genome',
  },
  ['/admin/onboarding']: {
    path: '/admin/onboarding',
    title: 'Onboarding',
  },
  ['/admin/onboarding/:id']: {
    path: '/admin/onboarding/:id',
    title: 'Onboarding Version',
    useRegexForMatching: true,
    regex: /^\/admin\/onboarding\/(\d+)$/,
  },
  ['/admin/onboarding/editor']: {
    path: '/admin/onboarding/editor',
    title: 'Onboarding Editor',
  },
  ['/admin/onboarding/editor/:id']: {
    path: '/admin/onboarding/editor/:id',
    title: 'Onboarding Editor',
    useRegexForMatching: true,
    regex: /^\/admin\/onboarding\/editor\/(\d+)$/,
  },
  ['/admin/onboarding/compare']: {
    path: '/admin/onboarding/compare',
    title: 'Onboarding Compare',
  },
  ['/admin/onboarding/inspector']: {
    path: '/admin/onboarding/inspector',
    title: 'Onboarding Inspector',
  },
  ['/admin/acquisition']: {
    path: '/admin/acquisition',
    title: 'Acquisition Strategies',
  },
  ['/admin/acquisition/new']: {
    path: '/admin/acquisition/new',
    title: 'New Acquisition Strategy',
  },
  ['/admin/acquisition/compare']: {
    path: '/admin/acquisition/compare',
    title: 'Compare Acquisition Strategies',
  },
  ['/admin/acquisition/:id/waiting']: {
    path: '/admin/acquisition/:id/waiting',
    title: 'Waiting to Get In',
    useRegexForMatching: true,
    regex: /^\/admin\/acquisition\/(\d+)\/waiting$/,
  },
  ['/admin/acquisition/:id']: {
    path: '/admin/acquisition/:id',
    title: 'Acquisition Strategy',
    useRegexForMatching: true,
    regex: /^\/admin\/acquisition\/(\d+)$/,
  },
  ['/admin/feature-wizards']: {
    path: '/admin/feature-wizards',
    title: 'Feature Wizards',
  },
  ['/admin/feature-wizards/new']: {
    path: '/admin/feature-wizards/new',
    title: 'New Feature Wizard',
  },
  ['/admin/feature-wizards/:id']: {
    path: '/admin/feature-wizards/:id',
    title: 'Edit Feature Wizard',
    useRegexForMatching: true,
    regex: /^\/admin\/feature-wizards\/(\d+)$/,
  },
  ['/onboarding']: {
    path: '/onboarding/*',
    title: 'Onboarding',
  },
  ['/integrations']: {
    path: '/integrations',
    title: 'Integrations',
  },
  ['/integrations/:name/callback']: {
    path: '/integrations/:name/callback',
    title: 'Integration Callback',
    useRegexForMatching: true,
    regex: /\/integrations\/([a-z A-Z 0-9]*)\/callback$/,
  },
  ['/post']: {
    path: '/post',
    title: 'Post',
  },
  ['/post/:id']: {
    path: '/post/:id',
    title: 'Post',
    useRegexForMatching: true,
    regex: /\/post\/([a-z A-Z 0-9]*)$/,
  },
  ['/calendar']: {
    path: '/calendar',
    title: 'Calendar',
  },
  ['/grow-audience']: {
    path: '/grow-audience',
    title: 'Get More Followers',
  },
  ['/grow-your-audience']: {
    path: '/grow-your-audience',
    title: 'Get More Followers',
  },
  ['/art-marketing-autopilot']: {
    path: '/art-marketing-autopilot',
    title: 'Art Marketing Autopilot',
  },
  ['/profile']: {
    path: '/profile',
    title: 'My Public Profile',
  },
  '*': {
    path: '*',
    title: 'Not Found',
  },
} as const;

export function getPageTitleByPath(path: string): string {
  if (path.match(ROUTES_CONFIG['/art/:id/chat/:conversationId'].regex))
    return ROUTES_CONFIG['/art/:id/chat/:conversationId'].title;
  if (path.match(ROUTES_CONFIG['/art/:id/chat'].regex)) return ROUTES_CONFIG['/art/:id/chat'].title;
  if (path.match(ROUTES_CONFIG['/art/:id'].regex)) return ROUTES_CONFIG['/art/:id'].title;
  if (path.match(ROUTES_CONFIG['/chat/:conversationId'].regex)) return ROUTES_CONFIG['/chat/:conversationId'].title;
  if (path.match(ROUTES_CONFIG['/shared/:chatId'].regex)) return ROUTES_CONFIG['/shared/:chatId'].title;
  if (path.match(ROUTES_CONFIG['/eval/:chatId'].regex)) return ROUTES_CONFIG['/eval/:chatId'].title;
  if (path.match(ROUTES_CONFIG['/tools/mocks/:imageId'].regex)) return ROUTES_CONFIG['/tools/mocks/:imageId'].title;
  if (path.match(ROUTES_CONFIG['/admin/onboarding/editor/:id'].regex))
    return ROUTES_CONFIG['/admin/onboarding/editor/:id'].title;
  if (path.match(ROUTES_CONFIG['/admin/onboarding/:id'].regex)) return ROUTES_CONFIG['/admin/onboarding/:id'].title;
  if (path.match(ROUTES_CONFIG['/admin/acquisition/:id/waiting'].regex))
    return ROUTES_CONFIG['/admin/acquisition/:id/waiting'].title;
  if (path.match(ROUTES_CONFIG['/admin/acquisition/:id'].regex)) return ROUTES_CONFIG['/admin/acquisition/:id'].title;
  if (path.match(ROUTES_CONFIG['/admin/feature-wizards/:id'].regex))
    return ROUTES_CONFIG['/admin/feature-wizards/:id'].title;

  const page = ROUTES_CONFIG[path as keyof typeof ROUTES_CONFIG];

  if (page) return page.title;

  return ROUTES_CONFIG['*'].title;
}
